import { SalesforceServices } from '@clearkit/icons';
import { CKButton } from 'clearkit';

import * as Well from './Well';

type WelcomeProps = {
  onGetStarted: () => void;
};
export function Welcome({ onGetStarted }: WelcomeProps) {
  return (
    <Well.Root>
      <Well.Icon>
        <SalesforceServices />
      </Well.Icon>
      <Well.Content>
        <Well.Heading>Enrich custom Salesforce objects</Well.Heading>
        <Well.Paragraph>
          For more advanced enrichment setups within Salesforce, you can
          configure custom objects to be enriched by Clearbit.
        </Well.Paragraph>
        <Well.Paragraph>
          Get started by linking custom objects to be enriched, then set up
          field mappings and your enrichment preferences as you would with
          standard Salesforce objects like Accounts, Contacts, and Leads.
        </Well.Paragraph>
        <CKButton onClick={onGetStarted} variantColor="blue">
          Get started
        </CKButton>
      </Well.Content>
    </Well.Root>
  );
}
